import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import constants from '../function/constants';

/* Function */
import ObjGeneral from '../function/';
import Constants from '../function/constants.js';
/* Local store */
import { localStoreFN } from '../../store/localStorage';
/* Actions */
import * as lastDataFfdPvtActions from '../../actions/last_data_ffd_pvt/index';
import * as lastDataFfdSleepActions from '../../actions/last_data_ffd_sleep/index';
import * as accountDriverActions from '../../actions/account_driver/index.js';
import * as dashboardActions from '../../actions/dashboard/index.js';
import * as workingShiftGroupsActions from '../../actions/common/working_shift_groups/index';
import * as headerActions from '../../actions/header/index.js';

/* Components */
import { Tooltip } from 'react-bootstrap';
import Header from '../../components/last_data_ffd_pvt/header';
import Table from '../../components/last_data_ffd_pvt/table';
import ModalFaults from '../../components/last_data_ffd_pvt/modalFaults';
import ButtonsTop from '../../components/last_data_ffd_pvt/buttonsTop';

import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Expired from '../expired/index';
import tourConfig from '../../components/common/tour/config';
import tourSteps from '../../components/last_data_ffd_pvt/tourSteps';

class LastDataFfdPvt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pag: 1,
      tagCategorySort: null,
      modalFaults: false,
      modalFaultsData: {
        faultTitle: null,
        htmlDetail: null
      },
      sort: {
        alias: null,
        category: null,
        group: null,
        ffdScore: "ASC",
        calcDate: null
      },
      firstOpen: true,
      isTourOpen: null,
      showErrorDownload: false,
    };
  }

  async componentDidMount() {
    // get the permissions to validate the view
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('ffdpvt');
    if (permit) {
      if (this.props.setting) {
        // get the setting objects
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('ffdpvt')) {
          const dateStart = this.props.filters.date.fechaStartFinal || null;
          const dateEnd = this.props.filters.date.fechaEndFinal || null;
          const driverId = this.props.filters.driver ? this.props.filters.driver.id : null;
          const tags = this.props.filters.tags;
          const periodReport = this.props.filters.periodReport;
          const workingShiftGroup = this.props.filters.workingShiftGroup || null;

          await this.props.workingShiftGroupsActions.fetchWorkingShiftGroupsApi();
        
          await this.props.accountDriverActions.fetchAccountDriverApi({
            dateStart,
            dateEnd,
            tags,
            seeFilter: true
          });

          this.props.actions.setFilterLastDataFfdPvt({
            periodReport: periodReport,
            date: this.props.filters.date,
            tags: this.props.filters.tags,
            workingShiftGroup: workingShiftGroup,
            driver: this.props.filters.driver
          });

          this.props.actions.setActiveStateLastDataFfdPvt({
            active:true
          });

          // call to Form's fetch api
          await this.props.actions.fetchLastDataFfdPvtApi({
            dateStart,
            dateEnd,
            tags,
            driver: driverId,
            workingShiftGroup,
            pag: this.state.pag
          });
          await this.props.actions.fetchLastDataFfdPvtCountApi({
            dateStart,
            dateEnd,
            tags,
            driver: driverId,
            workingShiftGroup
          });
          this.props.headerActions.setRepeatTourAction(this.openTour);
          // COUNT fetch api call
        } else {
          // not authorized
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      // not authorized
      this.props.history.push('/dashboard/authorization');
    }
  }

  // we load the reset function, return the states to their initial state
  componentWillUnmount() {
    this.props.actions.resetLastDataFfdPvt();
    this.props.headerActions.resetHeader();
  }

  openTour = () => {
    this.setState({
      isTourOpen: true
    });
  };  


  closeTour = async () => {
    const viewedTours = localStoreFN().getItem('viewedTours');
    const tourComplete = viewedTours ? JSON.parse(viewedTours)[Constants.toursKeys.summaryPvtLastResults] : false;
    if(tourComplete==false) {
      await this.props.dashboardActions.setTourViewed({tourName:Constants.toursKeys.summaryPvtLastResults});
    }

    this.setState({
      isTourOpen: false
    });
  };   
    
  componentDidUpdate = (prevProps, prevState) => {
    if(!this.props.loading && !this.props.accountDriverLoading 
        && this.props.status === 200 && this.props.statusTags === 200
        && this.props.accountDriverStatus === 200
        && this.state.firstOpen==true) {
      const viewedTours = localStoreFN().getItem('viewedTours');
      const tourComplete = viewedTours ? JSON.parse(viewedTours)[Constants.toursKeys.summaryPvtLastResults] : false;
      // tour load when the sight just enters
      this.state.firstOpen = false;
      if(tourComplete==false) {
        this.state.isTourOpen = true;
        tourConfig.openTourJsCall(tourSteps, this.closeTour, this.props.language, ".main-container.scroll");
      }
      else {
        this.state.isTourOpen = false;
      }
    }
  
    // tour loading when later called
    if(prevState.isTourOpen==false && this.state.isTourOpen==true) {
      tourConfig.openTourJsCall(tourSteps, this.closeTour, this.props.language, ".main-container.scroll");
    }
  }; 

  // function performed to sort the table
  handleSort = async event => {
    /* Change sort */
    const sort = { ...this.state.sort };
    let tagCategorySort = this.state.tagCategorySort;
    if (event.currentTarget.dataset.type === 'alias') {
      sort.category = null;
      sort.group = null;
      sort.ffdScore = null;
      sort.calcDate = null;
      tagCategorySort = null;
    } else if (event.currentTarget.dataset.type === 'category') {
      sort.alias = null;
      sort.group = null;
      sort.ffdScore = null;
      sort.calcDate = null;
      tagCategorySort = event.currentTarget.dataset.cat;
    } else if (event.currentTarget.dataset.type === 'group') {
      sort.alias = null;
      sort.category = null;
      sort.ffdScore = null;
      sort.calcDate = null;
      tagCategorySort = null;
    } else if (event.currentTarget.dataset.type === 'ffdScore') {
      sort.alias = null;
      sort.category = null;
      sort.group = null;
      sort.calcDate = null;
      tagCategorySort = null;
    } else if (event.currentTarget.dataset.type === 'calcDate') {
      sort.alias = null;
      sort.category = null;
      sort.group = null;
      sort.ffdScore = null;
      tagCategorySort = null;
    }
    const value = this.state.sort[event.currentTarget.dataset.type] == 'DESC' ? 'ASC' : 'DESC';
    sort[event.currentTarget.dataset.type] = value;
    /* Get Date */
    const date = this.props.filters.date;
    const driverId = this.props.filters.driver ? this.props.filters.driver.id : null;
          
    this.setState({ sort, tagCategorySort });
    this.setState({ pag: 1 });

    await this.props.actions.fetchLastDataFfdPvtNoLoadingApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      tags: this.props.filters.tags,
      driver: driverId,
      workingShiftGroup: this.props.filters.workingShiftGroup,
      sort,
      tagCategorySort,
      pag: 1,
    });
  };

  handleSubmit = async obj => {
    const tags = ObjGeneral.getTags(obj);
    const date =  this.props.filters.date;
    const workingShiftGroup = ObjGeneral.getWorkingShiftGroup(obj);
    const periodReport = ObjGeneral.getPeriodReport(obj);
    let driverId = this.props.filters.driver ? this.props.filters.driver.id : null;
    let driverObject = this.props.filters.driver ? this.props.filters.driver : null;
    const format = this.props.language.account.date.format;

    if (obj.id == 'driver') {
      driverId = Number.isInteger(obj.value) ? obj.value : 0;
      if (Number.isInteger(obj.value)) {
        driverObject = this.props.accountDriverDatos.find(o => o.id === obj.value);
      } else {
        driverObject = null;
      }
    }

    if (obj.target && obj.target.id == 'period-report') {
      switch(periodReport) {
        case constants.periodReportTypes.lastDataReport:
          date.fechaStartFinal = null;
          date.fechaEndFinal = null;
          break;
        case constants.periodReportTypes.lastWeekReport:
          date.fechaStartFinal = ObjGeneral.getDateFromNowWithDifference(7);
          date.fechaEndFinal = ObjGeneral.getDateFromNowWithDifference(0);
          break;
        case constants.periodReportTypes.lastMonthReport:
          date.fechaStartFinal = ObjGeneral.getDateFromNowWithDifference(30);
          date.fechaEndFinal = ObjGeneral.getDateFromNowWithDifference(0);
          break;
        case constants.periodReportTypes.lastThreeMonthsReport:
          date.fechaStartFinal = ObjGeneral.getDateFromNowWithDifference(30*3);
          date.fechaEndFinal = ObjGeneral.getDateFromNowWithDifference(0);
          break;
        case constants.periodReportTypes.lastSixMonthsReport:
          date.fechaStartFinal = ObjGeneral.getDateFromNowWithDifference(30*6);
          date.fechaEndFinal = ObjGeneral.getDateFromNowWithDifference(0);
          break;
        case constants.periodReportTypes.lastYearReport:
          date.fechaStartFinal = ObjGeneral.getDateFromNowWithDifference(365);
          date.fechaEndFinal = ObjGeneral.getDateFromNowWithDifference(0);
          break;
        case constants.periodReportTypes.customize:
          date.fechaStartFinal = ObjGeneral.getDateISO(obj.target.date.start, format);
          date.fechaEndFinal = ObjGeneral.getDateISO(obj.target.date.end, format);
          break;
        default:
          date.fechaStartFinal = null;
          date.fechaEndFinal = null;
          break;
      }
    }

    this.setState({ pag: 1 });

    this.props.actions.setFilterLastDataFfdPvt({
      date,
      tags: tags,
      workingShiftGroup: workingShiftGroup,
      driver: driverObject,
      periodReport: periodReport
    });

    /* Fetch */
    await this.props.accountDriverActions.fetchAccountDriverApi({
      seeFilter: true,
      tags: tags,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal
    });
    await this.props.actions.fetchLastDataFfdPvtApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      tags: tags,      
      driver: driverId,
      workingShiftGroup: workingShiftGroup,
      sort: this.state.sort,
      tagCategorySort: this.state.tagCategorySort,
      pag: 1
    });
    await this.props.actions.fetchLastDataFfdPvtCountApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      tags: tags,      
      driver: driverId,
      workingShiftGroup: workingShiftGroup
    });
  };

  // function performed to paginate
  handleScroll = async event => {
    if (!event.target.dataset.nonescroll && !this.state.isTourOpen) {
      if (!this.props.loadingTableSpiner) {
        if (this.state.pag < this.props.count.pages) {
          const scroll = event.target.scrollTop;
          const max = event.target.scrollHeight - event.target.offsetHeight;
          if (scroll >= max) {
            /* Change Pag */
            const pag = this.state.pag + 1;
            /* Get Date */
            const date =  this.props.filters.date;
            let driverId = this.props.filters.driver ? this.props.filters.driver.id : null;

            this.setState({ pag: pag });

            await this.props.actions.fetchLastDataFfdPvtNoLoadingApi({
              dateStart: date.fechaStartFinal,
              dateEnd: date.fechaEndFinal,
              tags: this.props.filters.tags,
              driver: driverId,
              workingShiftGroup: this.props.filters.workingShiftGroup,
              sort: this.state.sort,
              tagCategorySort: this.state.tagCategorySort,
              pag,
              concat: true,
            });
          }
        }
      }
    }
  };

  handleSubmitChangeFfdType = obj => {
    this.props.ffdSleepActions.setFilterLastDataFfdSleep({
      periodReport: this.props.filters.periodReport,
      date: this.props.filters.date,
      tags: this.props.filters.tags,
      workingShiftGroup: this.props.filters.workingShiftGroup,
      driver: this.props.filters.driver
    });
    //TAMBIEN ESTA EN EL DIDMOUNT setActiveStateLastDataFfdPvt
    this.props.actions.setActiveStateLastDataFfdPvt({
      active:false
    });
    this.props.history.push('/dashboard/last_data_ffd_sleep');
  };

  handleDownloadExcelSummary = async obj => {
    const dateStart = this.props.filters.date.fechaStartFinal;
    const dateEnd = this.props.filters.date.fechaEndFinal;

    // if there are errors, stop the execution
    const showErrorDownload = ObjGeneral.validateFFDReportDownload(dateStart, dateEnd);

    // set the state
    this.handleShowErrorDownload(showErrorDownload);

    if (showErrorDownload) {
      return;
    }

    // if there are no errors, continue with the download process
    await this.props.actions.downloadSummaryReport({
      dateStart: this.props.filters.date.fechaStartFinal,
      dateEnd: this.props.filters.date.fechaEndFinal,
      tags: this.props.filters.tags,
      driver: this.props.filters.driver ? this.props.filters.driver.id : null,
      workingShiftGroup: this.props.filters.workingShiftGroup,
      sort: this.state.sort,
      tagCategorySort: this.state.tagCategorySort,
    });
  };

  handleShowErrorDownload = (showErrorDownload) => {
    this.setState({
      showErrorDownload
    });
  }

  handleModalFaults = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalFaults ? false : true;
      this.setState({ modalFaults: reset });
      if (!reset) {
        this.setState({
          modalFaultsData: {
            faultTitle: null,
            htmlDetail: null
          }
        });
      } else {
        const detail = e.target.dataset.faultdetail;
        const title = e.target.dataset.faulttitle;

        this.setState({
          modalFaultsData: {
            faultTitle: title,
            htmlDetail: detail
          }
        });
      }
    }
  };

  render() {
    // condition done to see if the setting was done
    if (this.props.setting) {
      // the setting object is obtained which we use for the configuration
      const obj = JSON.parse(this.props.setting.value);
      const permits = localStoreFN().getItem('permits');
      
      const setting = ObjGeneral.getSetting({
        setting: obj.lastDataFFD,
        filter: this.props.filter,
        general: obj.generalSetting,
        isEnabledUbicationPVT: ObjGeneral.getIsEnabledUbicationPVT(obj),
        filterUbicationPVT: this.props.filterUbicationPVT
      });

      const header = (
        <Header
          handleSubmit={this.handleSubmit}
          language={this.props.language}
          filter={setting.filter}
          filterWorkingShiftGroups={this.props.filterWorkingShiftGroups}
          filters={this.props.filters}
          loadingFilter={this.props.loadingFilter}
          loadingWorkingShiftGroups={this.props.loadingWorkingShiftGroups}
          drivers={this.props.accountDriverDatos}
          defaultRangeInDay={obj.ffd.defaultRangeInDay}
          isRunUnitTest={this.props.isRunUnitTest || false}
        />
      );
      let container = '';
      // condition performed for loading state of the view
      if (this.props.loading || this.props.accountDriverLoading) {
        container = <Loading language={this.props.language} />;
        // the 401 status of the application Expired token or unauthorized
      } else if (
        this.props.status === 401 ||
        this.props.statusTags === 401 ||
        this.props.statusCount === 401 ||
        this.props.accountDriverStatus === 401
      ) {
        container = <Expired history={this.props.history} />;
        // the status 200 of the application success
      } else if (
        this.props.status === 200 &&
        this.props.statusTags === 200 &&
        this.props.accountDriverStatus === 200
      ) {
        container = (
          <div className="main-container scroll common-dashboards last-date-ffd-container fix-bad-tour-position">
            <ButtonsTop
              language={this.props.language ? this.props.language : ''}
              handleSubmit={this.handleSubmit}
              handleSubmitChangeFfdType={this.handleSubmitChangeFfdType}
              activeViews={obj.generalSetting.views}
              handleDownloadExcelSummary={this.handleDownloadExcelSummary}
              permits={permits}
            />
            <Table
              pag={this.state.pag}
              ffd={obj.ffd}
              tooltip={this.props.language.detail_fatigue.graphToolTip}
              datos={this.props.datos}
              title={this.props.language}
              language={this.props.language}
              handleSort={this.handleSort}
              loadingTable={this.props.loadingTableSpiner}
              count={this.props.count}
              reportType={this.props.filters.reportType}
              filter={setting.filter}
              sort={this.state.sort}
              tagCategorySort={this.state.tagCategorySort}
              handleFaultDetail={this.handleModalFaults}
            />
            <ModalFaults
              handleModal={this.handleModalFaults}
              modal={this.state.modalFaults}
              language={this.props.language ? this.props.language : ''}
              faultTitle={this.state.modalFaultsData.faultTitle}
              htmlDetail={this.state.modalFaultsData.htmlDetail}
            />
            <Tooltip placement="top" id="pageTooltip" />
            {this.state.showErrorDownload && (
                <SweetAlert
                  error
                  closeOnClickOutside={true}
                  confirmBtnCssClass="confirm-button"
                  title={
                    <span className="modal-title">
                      <strong>
                        {this.props.language.summary.ffdPvt.downloadErrorDateRangeTitle}
                      </strong>
                    </span>
                  }
                  onConfirm={() => this.handleShowErrorDownload(false)}
                >
                  <div className="tilte-modal-box">
                    {this.props.language.summary.ffdPvt.downloadErrorDateRangeDescription}
                  </div>
                </SweetAlert>
              )
            }
          </div>
        );
      } else if (
        this.props.status === 500 ||
        this.props.statusTags === 500 ||
        this.props.statusCount === 500 ||
        this.props.accountDriverStatus === 500
      ) {
        container = <Message message={this.props.language.error.apiError500} />;
      } else {
        container = <Message message={this.props.language.error.apiError} />;
      }
      return (
        <section className="main" onScroll={this.handleScroll}>
          {header}
          {container}
        </section>
      );
    }

    return (
      <section className="main">
        <Message message="NO Setting" />
      </section>
    );
  }
}
const mapStateToProps = state => ({
  filter: state.reducer.tags.filter,
  filterUbicationPVT: state.reducer.tags.filterUbicationPVT,
  statusTags: state.reducer.tags.status,
  loadingFilter: state.reducer.tags.loading,

  accountDriverDatos: state.reducer.accountDriver.datos,
  accountDriverStatus: state.reducer.accountDriver.status,
  accountDriverLoading: state.reducer.accountDriver.loading,

  filterWorkingShiftGroups: state.reducer.workingShiftGroups.filter,
  statusWorkingShiftGroups: state.reducer.workingShiftGroups.status,
  loadingWorkingShiftGroups: state.reducer.workingShiftGroups.loading,

  setting: state.reducer.dashboard.setting,

  count: state.reducer.lastDataFfdPvt.count,
  statusCount: state.reducer.lastDataFfdPvt.statusCount,
  datos: state.reducer.lastDataFfdPvt.datos,
  loading: state.reducer.lastDataFfdPvt.loading,
  status: state.reducer.lastDataFfdPvt.status,
  loadingTableSpiner: state.reducer.lastDataFfdPvt.loadingTableSpiner,
  filters: state.reducer.lastDataFfdPvt.filters,

  dateMax: state.reducer.dashboard.dateMax,
  language: state.reducer.dashboard.language
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(lastDataFfdPvtActions, dispatch),
  ffdSleepActions: bindActionCreators(lastDataFfdSleepActions, dispatch),
  accountDriverActions: bindActionCreators(accountDriverActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch),
  workingShiftGroupsActions: bindActionCreators(workingShiftGroupsActions, dispatch),
  headerActions: bindActionCreators(headerActions, dispatch)
});
LastDataFfdPvt.propTypes = {
  datos: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object
  ]).isRequired,
  actions: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  history: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LastDataFfdPvt);



// WEBPACK FOOTER //
// ./source/client/containers/last_data_ffd_pvt/index.jsx